import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromNews from '@fc-store/reducers/news.reducer';

export const getNewsState = createFeatureSelector<fromNews.State>(
  fromNews.newsFeatureKey,
);
export const getNews = createSelector(getNewsState, fromNews.getNews);

export const getShowNews = createSelector(getNewsState, fromNews.getShowNews);
